import { Button, ConfigProvider, Form, Typography } from 'antd';
import { useEffect, useState } from 'react';
import QuillWrapper from '../../../../common/utils/QuillWrapper';
import { usePostEditAppConfigMutation } from '../endpoint/appConfigEndpoint';
import { IGetAppConfig } from '../type/appConfig_Type';

type Props = {
  configDetails: IGetAppConfig | undefined;
};

const InvoiceExtraInfo = ({ configDetails }: Props) => {
  const [postEdit, { isLoading }] = usePostEditAppConfigMutation();
  const [content, setContent] = useState('');
  const prevNote = configDetails?.tac_invoice_footer_note;
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    const formattedData = {
      ...configDetails,
      tac_invoice_footer_note: values.tac_invoice_footer_note,
    };

    postEdit(formattedData);
    console.log(formattedData);
  };
  useEffect(() => {
    form.setFieldsValue({ tac_invoice_footer_note: prevNote });
  }, [prevNote, form]);
  return (
    <ConfigProvider>
      <Form
        form={form}
        layout='vertical'
        onFinish={onFinish}
        validateTrigger={['onBlur', 'onChange']}
        preserve={true}
      >
        <div
          style={{
            maxWidth: 900,
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: 35,
          }}
        >
          <Typography.Title level={4}>Invoice Footer Info</Typography.Title>
          <Form.Item
            label='Invoice Footer Info'
            name='tac_invoice_footer_note'
            rules={[{ required: true }]}
          >
            <QuillWrapper
              style={{ height: '500px', marginBottom: '50px' }}
              value={content}
              onBlur={(newContent) => setContent(newContent as any)}
            />
          </Form.Item>
          <Button htmlType='submit' loading={isLoading} style={{ float: 'right' }} type='primary'>
            Save
          </Button>
        </div>
      </Form>
    </ConfigProvider>
  );
};

export default InvoiceExtraInfo;
